import React from "react";
import {
  createStyles,
  useMantineColorScheme,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
} from "@mantine/core";
import AppLogo from "./components/AppLogo";

import SigmalyCover1 from "./assets/sigmaly-cover-1.webp";
import SigmalyCover2 from "./assets/sigmaly-cover-2.webp";

import SigmalyScanSolve from "./assets/sigmaly-scan-solve.webp";
import SigmalyChat from "./assets/sigmaly-chat.webp";
import SigmalyProblemOverview from "./assets/sigmaly-problem-overview.webp";
import SigmalyProblemOverview2 from "./assets/sigmaly-problem-overview-2.webp";
import SigmalyChatStart from "./assets/sigmaly-chat-start.webp";
import SigmalySnapHistory from "./assets/sigmaly-snap-history.webp";
import SigmalyMultilingual from "./assets/sigmaly-multilingual.webp";
import AppStoreButtonLight from "./assets/app_store_button-light.svg";
import AppStoreButtonDark from "./assets/app_store_button-dark.svg";

import { Link, useNavigate, useParams } from "react-router-dom";

function HomePage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();
  const { colorScheme } = useMantineColorScheme();
  return (
    <Box className={classes.container} {...otherProps}>
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify="center">
                <Center>
                  <AppLogo
                    variant="black"
                    onClick={() => navigation("/")}
                    sx={{ cursor: "pointer" }}
                  />
                </Center>

                <Text
                  weight={900}
                  size={46}
                  sx={{ color: "black" }}
                  align="center"
                >
                  Homework Helper & Math Solver
                </Text>
                <Text
                  weight={400}
                  size={24}
                  sx={{ color: "black" }}
                  align="center"
                >
                  Solve math problems instantly with AI-powered assistance. Snap
                  a photo, get step-by-step solutions, and ace your homework
                </Text>
              </Stack>
            </Center>
          </Box>
          <Box className={classes.section}>
            <Image src={SigmalyCover1} />
            <Center mt={20}>
              <Anchor href="#" target="_blank">
                <Image
                  src={AppStoreButtonLight}
                  width={200}
                  alt="Download Sigmaly AI on the App Store"
                />
              </Anchor>
            </Center>
          </Box>
          <Space h={30} />
        </Box>
      </Box>
      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "white",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Step-by-Step Solutions
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "white",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Understand every problem with detailed, easy-to-follow
                  explanations. Learn the concepts, not just the answers
                </Text>
              </Stack>

              <Image src={SigmalyProblemOverview} />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={SigmalyChatStart} w={"500px"} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Multiple Subjects Support
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  From algebra and geometry to calculus and statistics, get help
                  with any math subject at any level
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section}>
              <Center p={50}>
                <Stack spacing={0} justify="center">
                  <Text
                    weight={900}
                    size={36}
                    align="center"
                    sx={{
                      color: "white",
                      "@media (max-width: 565px)": {
                        fontSize: "1.7rem",
                        lineHeight: "1.9rem",
                      },
                    }}
                  >
                    Solve Math Problems Instantly
                  </Text>
                  <Text
                    weight={400}
                    size={24}
                    align="center"
                    sx={{
                      color: "white",
                      "@media (max-width: 565px)": {
                        fontSize: "1.3rem",
                        lineHeight: "1.5rem",
                      },
                    }}
                  >
                    From algebra to calculus, get instant solutions to any math
                    problem with detailed step-by-step explanations
                  </Text>
                </Stack>
              </Center>
            </Box>
            <Box className={classes.section}>
              <Image src={SigmalyCover2} />
              <Center mt={20}>
                <Anchor href="#" target="_blank">
                  <Image
                    src={AppStoreButtonDark}
                    width={200}
                    alt="Download Sigmaly AI on the App Store"
                  />
                </Anchor>
              </Center>
            </Box>
            <Space h={30} />
          </Box>
        </Box>
      </Box>

      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={SigmalyChat} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",

                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  AI Tutor Chat
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Get instant explanations and detailed guidance from your
                  personal AI tutor. Ask questions and learn at your own pace
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "white",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "2.1rem",
                    },
                  }}
                >
                  Snap, Scan & Solve
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "white",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Simply take a photo of any math problem and let our advanced
                  AI recognize and solve it in seconds
                </Text>
              </Stack>

              <Image src={SigmalyScanSolve} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Image src={SigmalyProblemOverview2} />
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Smart Problem Recognition
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Advanced AI instantly recognizes handwritten or printed math
                  problems from photos and provides accurate solutions
                </Text>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Stack spacing={0} p={20}>
                <Text
                  weight={900}
                  size={36}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.5rem",
                      lineHeight: "1.7rem",
                    },
                  }}
                >
                  Solution History & Progress
                </Text>
                <Text
                  weight={400}
                  size={24}
                  align="left"
                  sx={{
                    color: "black",
                    "@media (max-width: 565px)": {
                      fontSize: "1.3rem",
                      lineHeight: "1.5rem",
                    },
                  }}
                >
                  Keep track of all your solved problems and review them
                  anytime. Build your knowledge base with every solution
                </Text>
              </Stack>
              <Image src={SigmalySnapHistory} w={"500px"} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text
                weight={400}
                size={16}
                align="left"
                sx={{ color: "#E5E5E7" }}
              >
                Made with ❤️ and ☕️ by Anatoli Niculeac<sup>©</sup> 2025
              </Text>
              <Group spacing={10} p={20} position="right">
                <Anchor
                  component={Link}
                  to={"/support"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "#E5E5E7" }}
                  >
                    Support
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "#E5E5E7" }}
                >
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "#E5E5E7" }}
                  >
                    Terms of use
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "#E5E5E7" }}
                >
                  |
                </Text>
                <Anchor
                  component={Link}
                  to={"/privacy"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "#E5E5E7" }}
                  >
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text
                  weight={400}
                  size={16}
                  align="left"
                  sx={{ color: "#E5E5E7" }}
                >
                  |
                </Text>

                <Anchor
                  component={Link}
                  to={"/contact"}
                  className={classes.link}
                >
                  <Text
                    weight={400}
                    size={16}
                    align="left"
                    sx={{ color: "#E5E5E7" }}
                  >
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default HomePage;

const useStyles = createStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",

    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",

    backgroundColor: "#F4F3F0",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",
    backgroundColor: "#5856D6",
  },

  section: {
    maxWidth: 980,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },

  sectionTwo: {
    maxWidth: 980,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",

    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",

    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },

    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",

    gap: 20,
  },
  //   grid: {
  //     display: 'grid',
  //     gridTemplateColumns: '1fr auto 1fr',
  //     gridTemplateRows: 'auto',
  //     justifyContent: 'space-between',

  //     '@media (max-width: 425px)': {
  //       gridTemplateColumns: '1fr',
  //       gridTemplateRows: 'auto',
  //       justifyContent: 'center',
  //       alignContent: 'center',
  //       justifyItems: 'center',
  //     },
  //   },

  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",

    ":last-child": {
      borderRight: "none",
    },

    webkitTransition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    // WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    // outlineOffset: '-7px',

    ":hover": {
      transition: "0.5s color",
      textDecoration: "none",
      fontWeight: 600,
    },
    transition: "0.5s color",
  },
}));
